export default __webpack_public_path__ + "static/media/product8.249c6739.jpeg";